'use strict';

import _ from 'lodash';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state, $stateParams, $scope, $parse) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$scope = $scope;
    this.$parse = $parse
    this.newConf = {
      groups: []
    };

    this.newAppConfig = {}
    this.appConfig = {}

    this.configForm = [
      {
        groupTitle: '',
        items: [
          {
            key: 'dpiConfig.dpi',
            label: 'DPI设置',
            enable: false,
            value: 350,
            range: [200, 640],
            type: 'number'
          },
          {
            key: 'dpiConfig.enable',
            label: 'APP原始DPI（关闭DPI配置）',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'extraConfig.allowSplashScreen',
            label: '移除启动动画',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'extraConfig.forceFullScreen',
            label: '强制全屏',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'extraConfig.fullPMAccess',
            label: '后台持续运行',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'globalActivityConfig.displayConfig.enhance',
            label: '显示增强',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'globalActivityConfig.displayConfig.ditherThreshold',
            label: '高对比度',
            enable: false,
            value: 255,
            range: [128, 255],
            type: 'boolean'
          },
          {
            key: 'globalActivityConfig.noteConfig.enable',
            label: '手写优化',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'globalActivityConfig.noteConfig.globalStrokeStyle.strokeWidth',
            label: '线宽',
            enable: false,
            value: 3,
            range: [0.5, 20],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.paintConfig.antiAlisingType',
            label: '消除字体锯齿',
            enable: false,
            value: 0,
            range: [0, 100],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.paintConfig.fillContrast',
            label: '背景颜色',
            enable: false,
            value: 1,
            range: [0, 255],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.paintConfig.iconContrast',
            label: '图标颜色',
            enable: false,
            value: 1,
            range: [0, 255],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.paintConfig.imgEAC',
            label: '封面颜色',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'globalActivityConfig.paintConfig.textBold',
            label: '标题字体加粗',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'globalActivityConfig.paintConfig.textEACType',
            label: '文字描边',
            enable: false,
            value: 0,
            range: [0, 3],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.refreshConfig.animationDuration',
            label: '动画过滤时间',
            enable: false,
            value: 50,
            range: [0, 3000],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.refreshConfig.antiFlicker',
            label: '防闪烁',
            enable: false,
            value: 10,
            range: [0, 32],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.refreshConfig.gcInterval',
            label: '按点击次数全刷',
            enable: false,
            value: 20,
            range: [0, 50],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.refreshConfig.useGCForNewSurface',
            label: '页面切换时全刷',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'globalCSSConfig.fontBold',
            label: '网页文字加粗',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'globalCSSConfig.fontColor',
            label: '网页文字颜色',
            enable: false,
            value: 0,
            range: [0, 255],
            type: 'number'
          },
          {
            key: 'globalCSSConfig.fontSize',
            label: '网页字号',
            enable: false,
            value: 100,
            range: [100, 120],
            type: 'number'
          },
          {
            key: 'keyboardConfig.pageKeyMode',
            label: '侧键定义',
            enable: false,
            value: '',
            range: [
              {
                label: "翻页",
                value: 0
              },
              {
                label: "音量",
                value: 1
              },
              {
                label: "滚屏手势",
                value: 2
              }
            ],
            type: 'select'
          },
          {
            key: 'rotationConfig.enable',
            label: '强制旋转',
            enable: false,
            type: 'boolean',
            value: false
          },
          {
            key: 'scrollArgs.endYPercent',
            label: '结束位置',
            enable: false,
            value: 0.8,
            range: [0, 100],
            type: 'number'
          },
          {
            key: 'scrollArgs.startYPercent',
            label: '起始位置',
            enable: false,
            value: 0.2,
            range: [0, 100],
            type: 'number'
          },
          {
            key: 'scrollArgs.startYPercent',
            label: '起始位置',
            enable: false,
            value: 0.2,
            range: [0, 100],
            type: 'number'
          },
          {
            key: 'scrollArgs.startYPercent',
            label: '起始位置',
            enable: false,
            value: 0.2,
            range: [0, 100],
            type: 'number'
          },
          {
            key: 'globalActivityConfig.displayConfig.contrast',
            label: '深色增强',
            enable: false,
            type: 'number'
          },
          {
            key: 'globalActivityConfig.displayConfig.monoLevel',
            flag: 'black_white_screen',
            label: '浅色过滤',
            enable: false,
            type: 'number'
          },
          {
            key: 'globalActivityConfig.displayConfig.cfaColorBrightness',
            flag: 'color_screen',
            label: '色彩亮度',
            enable: false,
            type: 'number'
          },
          {
            key: 'globalActivityConfig.displayConfig.cfaColorSaturation',
            flag: 'color_screen',
            label: '鲜艳度增强',
            enable: false,
            type: 'number'
          },
          // {
          //   key: 'currentColorType',
          //   label: '色彩模式（黑白）',
          //   flag: 'black_white_screen',
          //   enable: false,
          //   value: '',
          //   range: [
          //     {
          //       label: "标准预设",
          //       value: 'eac_color_type_1',
          //       associationAttributes: [
          //         {
          //           type: 'default',
          //           attr:[
          //             {
          //               key: 'globalActivityConfig.displayConfig.monoLevel',
          //               label: '浅色过滤',
          //               value: 10,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.contrast',
          //               label: '深色增强',
          //               value: 80,
          //               type: 'number'
          //             }
          //           ],
          //           data: {
          //             appConfig: {
          //               globalActivityConfig: {
          //                 displayConfig: {
          //                   contrast: 80,
          //                   monoLevel: 10
          //                 }
          //               }
          //             }
          //           }
          //         }
          //       ]
          //     },
          //     {
          //       label: "浓墨预设",
          //       value: 'eac_color_type_2',
          //       associationAttributes: [
          //         {
          //           type: 'default',
          //           attr:[
          //             {
          //               key: 'globalActivityConfig.displayConfig.monoLevel',
          //               label: '浅色过滤',
          //               value: 10,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.contrast',
          //               label: '深色增强',
          //               value: 80,
          //               type: 'number'
          //             }
          //           ],
          //           data: {
          //             appConfig: {
          //               globalActivityConfig: {
          //                 displayConfig: {
          //                   contrast: 80,
          //                   monoLevel: 10
          //                 }
          //               }
          //             }
          //           }
          //         }
          //       ]
          //     },
          //     {
          //       label: "自定义",
          //       value: 'eac_color_type_3',
          //       associationAttributes: [
          //         {
          //           type: 'custom',
          //           attr:[
          //             {
          //               key: 'globalActivityConfig.displayConfig.monoLevel',
          //               label: '浅色过滤',
          //               value: 0,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.contrast',
          //               label: '深色增强',
          //               value: 0,
          //               type: 'number'
          //             }
          //           ],
          //           data: {
          //             globalActivityConfig: {
          //               displayConfig: {
          //                 contrast: 0,
          //                 monoLevel: 0
          //               }
          //             }
          //           }
          //         }
          //       ]
          //     }
          //   ],
          //   type: 'select'
          // },
          // {
          //   key: 'currentColorType',
          //   label: '色彩模式（彩屏）',
          //   enable: false,
          //   flag: 'color_screen',
          //   value: '',
          //   range: [
          //     {
          //       label: "均衡预设",
          //       value: 'eac_color_type_1',
          //       associationAttributes: [
          //         {
          //           type: 'default',
          //           attr:[
          //             {
          //               key: 'globalActivityConfig.displayConfig.cfaColorBrightness',
          //               label: '色彩亮度',
          //               value: 0,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.cfaColorSaturation',
          //               label: '鲜艳度增强',
          //               value: 0,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.contrast',
          //               label: '深色增强',
          //               value: 30,
          //               type: 'number'
          //             }
          //           ],
          //           data: {
          //             appConfig: {
          //               globalActivityConfig: {
          //                 displayConfig: {
          //                   cfaColorBrightness: 0,
          //                   cfaColorSaturation: 0,
          //                   contrast: 30
          //                 }
          //               }
          //             }
          //           }
          //         }
          //       ]
          //     },
          //     {
          //       label: "鲜艳预设",
          //       value: 'eac_color_type_2',
          //       associationAttributes: [
          //         {
          //           type: 'default',
          //           attr:[
          //             {
          //               key: 'globalActivityConfig.displayConfig.cfaColorBrightness',
          //               label: '色彩亮度',
          //               value: 0,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.cfaColorSaturation',
          //               label: '鲜艳度增强',
          //               value: 50,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.contrast',
          //               label: '深色增强',
          //               value: 30,
          //               type: 'number'
          //             }
          //           ],
          //           data: {
          //             appConfig: {
          //               globalActivityConfig: {
          //                 displayConfig: {
          //                   cfaColorBrightness: 0,
          //                   cfaColorSaturation: 50,
          //                   contrast: 30
          //                 }
          //               }
          //             }
          //           }
          //         }
          //       ]
          //     },
          //     {
          //       label: "自定义",
          //       value: 'eac_color_type_3',
          //       associationAttributes: [
          //         {
          //           type: 'custom',
          //           attr:[
          //             {
          //               key: 'globalActivityConfig.displayConfig.cfaColorBrightness',
          //               label: '色彩亮度',
          //               value: 0,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.cfaColorSaturation',
          //               label: '鲜艳度增强',
          //               value: 0,
          //               type: 'number'
          //             },
          //             {
          //               key: 'globalActivityConfig.displayConfig.contrast',
          //               label: '深色增强',
          //               value: 0,
          //               type: 'number'
          //             }
          //           ],
          //           data: {
          //             appConfig: {
          //               globalActivityConfig: {
          //                 displayConfig: {
          //                   cfaColorBrightness: 0,
          //                   cfaColorSaturation: 0,
          //                   contrast: 0
          //                 }
          //               }
          //             }
          //           }
          //         }
          //       ]
          //     }
          //   ],
          //   type: 'select'
          // },
          {
            key: 'globalActivityConfig.refreshConfig.refreshModeIndex',
            label: '刷新模式',
            enable: false,
            value: '',
            range: [
              {
                label: "净清",
                value: 'refresh_mode_1'
              },
              {
                label: "标准",
                value: 'refresh_mode_2'
              },
              {
                label: "极速",
                value: 'refresh_mode_3'
              }
            ],
            type: 'select'
          },
        ]
      }
    ],
    this.specialConfig = {
      updateModePad: {
        '1': {
          "turbo": 0,
          "updateMode": 0
        },
        '2': {
          "turbo": 2,
          "updateMode": 2
        },
        '3': {
          "turbo": 4,
          "updateMode": 2
        },
        '4': {
          "turbo": 5,
          "updateMode": 2
        },
        '5': {
          "turbo": 0,
          "updateMode": 3
        }
      },
      updateModePadEink: {
        '1': {
          "turbo": 0,
          "updateMode": 0
        },
        '2': {
          "turbo": 0,
          "updateMode": 2
        },
        '3': {
          "turbo": 2,
          "updateMode": 2
        },
        '4': {
          "turbo": 3,
          "updateMode": 2
        },
        '5': {
          "turbo": 0,
          "updateMode": 3
        }
      },
      updateModePhone: {
        '1': {
          "turbo": 0,
          "updateMode": 0
        },
        '2': {
          "turbo": 0,
          "updateMode": 2
        },
        '3': {
          "turbo": 1,
          "updateMode": 2
        },
        '4': {
          "turbo": 2,
          "updateMode": 2
        },
        '5': {
          "turbo": 0,
          "updateMode": 3
        }
      },
      updateModeEink: {
        '1': {
          updateMode: 0
        },
        '2': {
          updateMode: 3
        },
        '3': {
          updateMode: 2
        },
        '4': {
          updateMode: 1
        },
        '5': {
          updateMode: 4
        }
      }
    }
    this.tmpConf = null
    this.isRepeat = false
    this.type = 0
    this.existConfs = null

    this.flags = [
      {
        label: '彩屏',
        value:'color_screen',
      },
      {
        label: '黑白屏',
        value:'black_white_screen',
      },
      {
        label: '手机',
        value: 'phone',
      },
      {
        label: '平板',
        value:'pad',
      },
    ]
  }

  $onInit() {
    this.type = this.$stateParams.type ? +this.$stateParams.type : this.type
    this.getList();

    this.$scope.$watchCollection('acAddCtrl.newAppConfig', (newVal, oldVal) => {
      this.updateAppConfig()
    })
  }

  transformConfigArray(configArray) {
    const transformedObject = {};

    configArray.forEach(config => {
        if (!config.enable) {
          return
        }
        const keys = config.key.split('.');
        let currentLevel = transformedObject;

        for (let i = 0; i < keys.length; i++) {
            if (i === keys.length - 1) {
                if (this.specialConfig[keys[i]] && this.specialConfig[keys[i]][config.value]) {
                  const tmpObj = this.specialConfig[keys[i]][config.value]
                  for (const key in tmpObj) {
                    currentLevel[key] = tmpObj[key];  
                  }
                  currentLevel['rename'] = keys[i]
                } else {
                  currentLevel[keys[i]] = config.value;
                }
            } else {
                currentLevel[keys[i]] = currentLevel[keys[i]] || {};
                currentLevel = currentLevel[keys[i]];
            }
        }
    });

    return transformedObject;
  }

  updateConfigData() {
    let obj = {}

    for (const group of this.configForm) {
      const res = this.transformConfigArray(group.items)
      obj = Object.assign(obj, res)
    }
    if (JSON.stringify(obj) !== this.newConf.config) {
      this.newConf.config = JSON.stringify(obj)
    }
  }

  updateDefaultConfigData(data, checked) {
    if (!checked) {
      delete this.newAppConfig[data.key]
    } else {
      if (data.value !== '' || data.value !== undefined) {
        this.newAppConfig[data.key] = data.value 
      }
    }
    this.updateAppConfig()
  }

  updateAppConfig() {
    this.appConfig = {}
    for(var key in this.newAppConfig) {
      this.setNestedProperty(key, this.newAppConfig[key]);
    }
    if (Object.keys(this.appConfig).length) {
      this.newConf.config = JSON.stringify(this.appConfig, null, 4)
    } else {
      this.newConf.config = ''
    }
  }

  setNestedProperty(path, value) {
    var setter = this.$parse(path).assign;
    
    if (angular.isFunction(setter)) {
      this.ensurePathExists(this.appConfig, path);
      
      setter(this.appConfig, value);
    } else {
      console.error("不能设置嵌套属性：", path);
    }
  };

  getNestedProperty(path) {
    var getter = this.$parse(path)
    try {
      return getter(this.newAppConfig)
    } catch (error) {
      this.setNestedProperty(path, undefined)
      return undefined
    }
  }

  ensurePathExists(obj, path) {
    var parts = path.split('.');
    var current = obj;
    
    for (var i = 0; i < parts.length - 1; i++) {
      var part = parts[i];
      
      // 如果当前层级不存在，则创建新对象
      if (current[part] === undefined || current[part] === null) {
        current[part] = {};
      }
      
      // 向下移动到下一层级
      current = current[part];
    }
  }

  selectedItem(key, data) {
    const item = data.range.find(a => a.value === key)
    if (!item) {
      return
    }
    if (item.associationAttributes) {
      for (const attrItem of item.associationAttributes) {
        for (const a of attrItem.attr) {
          this.newAppConfig[a.key] = a.value
        }
      }
    }
    return item
  }

  add() {
    // this.updateConfigData()
    this.newConf.type = this.type
    this.$http.post(`api/AppConfs`, this.newConf).then(response => {
      if (this.type) {
        this.$state.go('codeappconfs')
      } else {
        this.$state.go('appconfs');
      }
    });
  }

  getList() {
    this.$http.get('/api/AppConfGroups').then(res => {
      this.groups = res.data;
    });
  }

  toggleSelection(id) {
    let idx = this.newConf.groups.indexOf(id);
    if(idx > -1) {
      this.newConf.groups.splice(idx, 1);
    } else {
      this.newConf.groups.push(id);
    }
  }

  toggleFlagsSelection(val) {
    if (!this.newConf.flags) {
      this.newConf.flags = []
    }
    let flags = this.newConf.flags.indexOf(val);
    if(flags > -1) {
      this.newConf.flags.splice(flags, 1);
    } else {
      this.newConf.flags.push(val);
    }
  }

  getTmpConf() {
    const code = this.newConf.code
    const pkg = this.newConf.pkg
    const recommendedBy = this.newConf.recommendedBy

    const params = {
      
    }

    if (code.length === 4) {
      params.code = code
    }

    if (pkg && recommendedBy) {
      params.pkg = pkg
      params.recommendedBy = recommendedBy
    }

    if (Object.keys(params).length === 0) {
      return
    }

    this.$http.post('/api/AppConfs/getConf', params).then(response => {
      this.checkRecommendedByRepeat(response.data)
    }).catch(err => {
      console.log(err)
      this.tmpConf = null
    });
  }

  checkRecommendedByRepeat(conf) {
    const confByCode = conf.findByCode
    const confByRecommend = conf.findByRecommend

    if (confByCode && confByCode.length) {
      this.newConf.recommendedBy = confByCode[0].recommendedBy
      this.existConfs = confByCode.map(item => item.name).join(',')
    }

    if (confByRecommend && confByRecommend.code !== this.newConf.code && confByRecommend.pkg === this.newConf.pkg && confByRecommend.recommendedBy === this.newConf.recommendedBy) {
      this.isRepeat = true
    } else {
      this.isRepeat = false
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/appconfs/add/add.controller.js